const namespace = "COURSE_PAYMENT";

export const CONSTANTS = {
  CREATE_ORDER: `${namespace}_CREATE_ORDER`,
  PAYMENT_CHECKOUT: `${namespace}_PAYMENT_CHECKOUT`,
  CHECK_PAYMENT_STATUS: `${namespace}_CHECK_PAYMENT_STATUS`,
  CREATE_ORDER_POST: `${namespace}_CREATE_ORDER_POST`,
  CREATE_ORDER_POST_DYNAMIC_BUNDLING: `${namespace}_CREATE_ORDER_POST_DYNAMIC_BUNDLING`,
  PAYMENT_CHECKOUT_GET: `${namespace}_PAYMENT_CHECKOUT_GET`,
  CHECK_PAYMENT_STATUS_GET: `${namespace}_CHECK_PAYMENT_STATUS_GET`,
  ADD_TO_CART_POST: `${namespace}_ADD_TO_CART_POST`,
  GET_SIGNED_PAYLOAD_GET: `${namespace}_GET_SIGNED_PAYLOAD_GET`,
  PAYMENT_METHODS_GET: `${namespace}_METHODS_GET`,
  CREATE_CAPTURE_INTEREST: `${namespace}_CREATE_CAPTURE_INTEREST`,
  GET_QR_PAYMENT_STATUS_RZP: `${namespace}_QR_PAYMENT_STATUS_RZP`,
};

export const PAYMENT_GATWAY_ENUMS = {
  RAZORPAY: "rzp",
  TAZAPAY: "tzp",
  RAPYD: "rpd",
  GOOGLE: "google",
  RAZORPAY_QR: "rzp_qr",
};

export const QR_PAYMENT_TIMEOUT = 300
export const PAYMENT_STATUS = {
  pending: "pending",
  paid:"paid",
  failed: "failed"
}